module.exports = __webpack_public_path__ + "static/media/aes-logo-white.2339cccb.png";